'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

if (typeof consultationsData !== 'undefined') {
EwSiteApp.config(['uibDatepickerConfig', function (uibDatepickerConfig) {
		uibDatepickerConfig.showWeeks = false;
		uibDatepickerConfig.startingDay = 1;
		uibDatepickerConfig.formatDay = "d";
		uibDatepickerConfig.datepickerPopup = "yyyy-MM-dd";
		uibDatepickerConfig.minDate = new Date(consultationsData.minDate);
		uibDatepickerConfig.maxDate = new Date(consultationsData.maxDate);
	}]);
EwSiteApp.controller('consultationsCtrl',['$scope', '$sce', '$filter', '$http', '$log', '$timeout', function ($scope, $sce, $filter, $http, $log, $timeout) {

	$scope.dataUrl = consultationsData.dataUrl;
	$scope.postUrl = consultationsData.postUrl;
	$scope.loading = false;
	$scope.form_loading = false;
	$scope.step = 1;
	$scope.day = {};
	$scope.reserved_time = {};
	$scope.errors = [];
	$scope.show_times = false;
	$scope.finished = false;
	$scope.jsdisplay = new Date();

	$scope.dates = consultationsData.dates;
	$scope.datepickerOptions = {
		dateDisabled: myDisabledDates,
		customClass: getCustomClass
	};
	$scope.form;
	$scope.submitted = false;
	
	function getCustomClass (dateAndMode) {
		let customClass = '';
		if (dateAndMode.mode === 'day') {
			let monthToCheck = dateAndMode.date.getMonth();
//			jeigu reiktu aktyvaus menesio kalendoriuje
			let activeMonth = this.datepicker.activeDate.getMonth();
//			let activeMonth = new Date().getMonth();
			if (monthToCheck !== activeMonth) {
				customClass = 'notthismonth';
			}
		}
		return customClass;
	}
	
	function areDatesEqual(date1, date2) {
		return (date1 * 1000) === date2;
	}

	$scope.loadData = function (date_changed) {
		if(typeof date_changed !== 'undefined' || date_changed){
			$scope.show_times = true;
		}
		else {
			$scope.show_times = false;
		}
		$scope.jsdisplay.setHours(0, 0, 0, 0);
		$scope.jsdisplaydate = $filter('date')($scope.jsdisplay, 'yyyy-MM-dd');
		var date = ($scope.jsdisplay.getTime() / 1000);

		if ($scope.dataUrl !== '') {
			$scope.loading = true;
			$http({
				method: 'GET',
				url: $scope.dataUrl,
				params: {
//					date: date
					date: $scope.jsdisplaydate
				}
			}).then(function (response) {
				if(response.data.success){
					$scope.loading = false;
					$scope.day = response.data.day;
					if(date_changed && $scope.step<3){
						$scope.step = 2;
					}
				}
				else {
					$scope.step = 1;
					$scope.reserved_time = {};
					$scope.show_times = false;
					$scope.finished = false;
				}
			}, function (response) {
				console.log(['Error', response]);
			});
		}
	};
	$scope.loadData();

	function myDisabledDates(dateAndMode) {
		var isDateDisabled = false;
		$scope.dates.forEach((date) => {
			if (areDatesEqual(date.time, dateAndMode.date.getTime())) {
				isDateDisabled = true;
			}
		});
		return (dateAndMode.mode === 'day' && (dateAndMode.date.getDay() === 6 || dateAndMode.date.getDay() === 0 || isDateDisabled));//Saturdays, Sundays, Disabled off
	}

	$scope.$watch('jsdisplay', function (newVal, oldVal) {
		if (newVal.setHours(0, 0, 0, 0) !== oldVal.setHours(0, 0, 0, 0)) {
			$scope.step = 1;
			$scope.loadData(true);
		}
	});
	
	$scope.chooseTime = function(time){
		$scope.step = 2;
		$scope.form_loading = true;
		$scope.day.times.forEach((time) => {
			if (time.selected) {
				time.selected = false;
			}
		});
		time.selected = true;
		
//		time.time_string = new Date(time.time*1000);
//		time.time_string = $filter('date')(time.time_string, 'yyyy-MM-dd HH:mm');
		time.time_string = time.ymd + ' ' + time.start_time;
		
		$scope.reserved_time = time;
		$timeout(function(){
			$scope.form_loading = false;
			$scope.step = 3;
		}, 200); // uzdelsimas del animacijos
	};
	$scope.selectedTimeClass = function(time){
		let customClass = '';
		if(time.selected){
			customClass = 'timeselected';
		}
		return customClass;
	};
	
	$scope.submit = function(){
		if ($scope.postUrl !== '') {
			
			$scope.submitted = true;
			$scope.loading = true;
			
			if (typeof grecaptcha !== 'undefined') {
				grecaptcha.ready(function() {
					grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action:'submit'}).then(function(token) {
//						$scope.reserved_time.recaptchaResponse = token;
						if(typeof consultationsData.recaptcha !== 'undefined'){
							$scope.reserved_time[consultationsData.recaptcha.field] = token;

							$http({
								method: 'POST',
								url: $scope.postUrl,
								xsrfCookieName: secure_xsrf_name,
								xsrfHeaderName: 'X-' + secure_xsrf_name,
								data: $scope.reserved_time,
							}).then(function (response) {
								$scope.step = 1;
								$scope.loading = false;
								if(response.data.success) {
									$scope.loadData(false);
									$scope.finished = response.data.success;
								}
								else if(angular.isDefined(response.data.messages)){
									$scope.errors = response.data.messages;
									$scope.loadData(false);
								}
								if(angular.isDefined(response.data.debug)){
									$log.debug(response.data.debug);
								}
							}, function (response) {
								console.log(['Error', response]);
							});

						}
					});
				});
			}
			
//			$http({
//				method: 'POST',
//				url: $scope.postUrl,
//				xsrfCookieName: secure_xsrf_name,
//				xsrfHeaderName: 'X-' + secure_xsrf_name,
//				data: $scope.reserved_time,
//			}).then(function (response) {
//				$scope.step = 1;
//				$scope.loading = false;
//				if(response.data.success) {
//					$scope.loadData(false);
//					$scope.finished = response.data.success;
//				}
//				else if(angular.isDefined(response.data.messages)){
//					$scope.errors = response.data.messages;
//					$scope.loadData(false);
//				}
//				if(angular.isDefined(response.data.debug)){
//					$log.debug(response.data.debug);
//				}
//			}, function (response) {
//				console.log(['Error', response]);
//			});
		}
	};
	
	$scope.hasErrors = function () {
		return $scope.errors.length > 0;
	};
	
	$scope.goBack = function(){
		$scope.finished = false;
		$scope.step = 2;
//		$scope.loadData();
	};
}]).directive('formSubmit', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
});
}